import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/layout/WhatsAppFloat";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { Products } from "@/components/home/Products";
import { CardamomGrading } from "@/components/home/CardamomGrading";
import { WhyUs } from "@/components/home/WhyUs";
import { ProcessSummary } from "@/components/home/ProcessSummary";
import { BuyersServe } from "@/components/home/BuyersServe";
import { Credentials } from "@/components/home/Credentials";
import { EnquirySection } from "@/components/home/EnquirySection";
import { localBusinessSchema } from "@/lib/schema";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-spice-cream" data-testid="home-page">
      <Seo
        title="Nandanaaya Spices | Wholesale Cardamom & Spices Hyderabad"
        description="Wholesale green cardamom, black pepper and selected whole spices for commercial buyers in Hyderabad and Telangana. Request current lot availability and quotation."
        path="/"
        jsonLd={localBusinessSchema()}
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Products
          heading="Core Products"
          intro="Green cardamom, black pepper and selected whole spices supplied in wholesale lots. Rates are quoted against the current lot."
        />
        <CardamomGrading showGallery />
        <WhyUs />
        <ProcessSummary />
        <BuyersServe />
        <Credentials />
        <EnquirySection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
